/* eslint-disable no-console */

export class ConsolePanel {
  constructor (element, options = {}) {
    this.element = element;
    this.options = {
      maxEntries: 500,
      showTimestamps: true,
      ...options
    };
    this.queue = [];
    this.originalConsole = null;
  }

  init () {
    if (!this.element) {
      console.warn('ConsolePanel init called without element');
      return;
    }
    this.originalConsole = {
      log: console.log,
      warn: console.warn,
      error: console.error,
      info: console.info
    };
    this.patchConsole();
  }

  patchConsole () {
    const levels = ['log', 'warn', 'error', 'info'];
    levels.forEach(level => {
      console[level] = (...args) => {
        this.originalConsole[level](...args);
        this.renderEntry(level, args);
      };
    });
  }

  renderEntry (level, args) {
    const message = args.map(arg => {
      if (typeof arg === 'object') {
        try {
          return JSON.stringify(arg, null, 2);
        } catch (error) {
          return String(arg);
        }
      }
      return String(arg);
    }).join(' ');

    const entry = document.createElement('div');
    entry.className = `console-line console-${level}`;

    if (this.options.showTimestamps) {
      const timestamp = document.createElement('span');
      timestamp.className = 'console-timestamp';
      timestamp.textContent = new Date().toLocaleTimeString();
      entry.appendChild(timestamp);
    }

    const text = document.createElement('span');
    text.className = 'console-message';
    text.textContent = message;
    entry.appendChild(text);

    this.element.appendChild(entry);
    this.queue.push(entry);

    while (this.queue.length > this.options.maxEntries) {
      const oldEntry = this.queue.shift();
      if (oldEntry?.parentNode) {
        oldEntry.parentNode.removeChild(oldEntry);
      }
    }

    this.element.scrollTop = this.element.scrollHeight;
  }

  clear () {
    this.queue.forEach(entry => {
      if (entry?.parentNode) {
        entry.parentNode.removeChild(entry);
      }
    });
    this.queue = [];
  }
}
